import { I18nComponente } from "@/types/gerais"

export const AEstadoVazioTabelai18n: I18nComponente = {
  "pt-BR": {
    nenhumResultadoEncontrado: "Nenhum resultado encontrado"
  },
  "es-CO": {
    nenhumResultadoEncontrado: "Ningún resultado encontrado"
  }
}
